<template>
  <div class="wechatIot-container app-container">
    <div class="wechatIot-header bg-white">
      <!-- <div class="wechatIot-header-top">
        <div>
          <p>机构数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>设备数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>用户数(人)</p>
          <p>13000</p>
        </div>
      </div> -->
      <div class="wechatIot-header-bottom">
        <!-- <list-search @listSearchEvn="listSearchEvn" /> -->
        <div class="wechatIot-header-bottom-date">
          <div class="booxCloud-date-select">
            <span
              v-for="item in dateType"
              :key="item.type"
              class="booxCloud-date-select-item"
              :class="{
                'booxCloud-date-select-active': type === item.type,
              }"
              @click="changeType(item.type)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="wechatIot-main" v-bar>
      <div>
        <BaseLineChart
          v-if="wechatIotData"
          :title="
            wechatIotData.title ? wechatIotData.title : '微信硬件绑定用户统计'
          "
          :chartData="wechatIotData"
        ></BaseLineChart>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLineChart from "./components/baseLineChart";
export default {
  components: {
    BaseLineChart,
  },
  data() {
    return {
      wechatIotData: null,
      type: "day",
      wechatIotParams: {
        type: "day",
      },
      dateType: [
        {
          type: "day",
          label: "天",
        },
        {
          type: "week",
          label: "周",
        },
        {
          type: "month",
          label: "月",
        },
        {
          type: "year",
          label: "年",
        },
      ],
    };
  },
  methods: {
    changeType(type) {
      if (this.type === type) return;
      this.type = type;
      this.wechatIotParams.type = type;
      this.getWechatIotByDate();
    },
    async getWechatIotByDate() {
      try {
        let res = await this.$http.wechatIotByDate(this.wechatIotParams);
        this.wechatIotData = res.data;
      } catch (error) {
        throw error;
      }
    },
  },
  mounted() {
    this.getWechatIotByDate();
  },
};
</script>

<style lang="scss">
.wechatIot-container {
  .wechatIot-header {
    padding: 10px 50px;
    .wechatIot-header-top {
      display: flex;
      justify-content: space-around;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
    }
    .wechatIot-header-bottom {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .wechatIot-header-bottom-date {
        display: flex;
        align-items: center;
        .booxCloud-date-select {
          .booxCloud-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .booxCloud-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .booxCloud-date-select {
    .booxCloud-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .booxCloud-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .wechatIot-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
